module.exports = __webpack_public_path__ + "img/sound-wave.6f4b763b.png";